<template>
  <div class="bgg">
    <div class="bg-image bg-image-register pt-5 pb-5">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-sm-12 col-lg-12">

            <div class="signUpActivation b-white p-5 rounded b-shadow text-center" v-if="( (type === 'enterprise') || (type === 'trainer') ) && (signUpActivation)">
              <h1 class="font-blue">¡Listo!</h1>
              <p>
                Tu información está siendo validada. <br>
                Mantente al pendiente, en un tiempo máximo de <b>48 hrs.</b> <br>
                recibirás un correo en <b class="font-orange">{{email}}</b>.
              </p>
              <p>
                Recuerda revisar tu bandeja de correos no deseados para asegurarte <br>
                de que lo hayas recibido. <br>
                Una vez que lo recibas, activa tu cuenta ¡y accede!
              </p>
              <h2 class="font-blue">¡Gracias por registrarte!</h2>
              <button @click="rediretTo('/')" class="btn b-orange shadow my-3"> Volver a inicio</button>
              <button @click="rediretTo('/registrar')" class="btn b-transparent my-3"> Registrar otra cuenta</button>
            </div>
            <div class="signUpActivation b-white p-5 rounded b-shadow text-center" v-if="(type === 'student') && (signUpActivation)">
              <h1 class="font-blue">¡Listo!</h1>
              <div class="row justify-content-md-center">
                <p class="col-6 ">
                  Recuerda revisar tu bandeja de correos (<b class="font-orange">{{email}}</b>) en correos no deseados para asegurarte
                  de que lo hayas recibido un correo de validación.
                  Una vez que lo recibas, activa tu cuenta ¡y accede!
                </p>
              </div>

              <h2 class="font-blue">¡Gracias por registrarte!</h2>
              <button @click="rediretTo('/')" class="btn b-orange shadow my-3"> Volver a inicio</button>
              <button @click="rediretTo('/registrar')" class="btn b-transparent my-3"> Registrar otra cuenta</button>
            </div>

            <formTrainer    :exist_email="exist_email" v-if="(type === 'trainer') && (!signUpActivation)" />
            <formEnterprise :exist_email="exist_email" v-if="(type === 'enterprise') && (!signUpActivation)"/>
            <formStudent    :exist_email="exist_email" v-if="(type === 'student') && (!signUpActivation)"/>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@media only screen and (min-width: 320px) {
  .bgg {
    background-color: #244076 !important
  }
}
</style>
<script>

import formEnterprise from "./pages/formEnterprise";
import formTrainer from "./pages/formTrainer";
import formStudent from "./pages/formStudent";

export default {
  components: {
    formEnterprise,
    formTrainer,
    formStudent
  },
  data() {
    return {
      signUpActivation: false,
      type:'',
      user_id:'',
      user_email:'',
      exist_email: true,
      user_provider:'',
      email:'ejemplo@kllaar.com'
    }
  },
  created() {
    this.showTypeUser()
    this.$store.commit('setValidationSocial', true)

    this.$bus.$on('registerEnterprise', (form)=>{
      this.sendEnterprise(form)
    })

    this.$bus.$on('registerTrainer', (form)=>{
      this.sendTrainer(form)
    })

    this.$bus.$on('registerStudent', (form)=>{
      this.sendStudent(form)
    })

  },
  methods:{
    rediretTo(url){
      window.location.href = url
    },
    showTypeUser(){

      let strings = window.location.search
      let params = new URLSearchParams(strings)
      let v = params.get('vtoail')

      if(v){

        this.type           = atob(params.get('ttoail'))
        this.user_id        = atob(params.get('itoail'))
        this.user_email     = atob(params.get('etoail'))
        this.user_provider  = atob(params.get('ptoail'))
        this.exist_email    = params.get('eetoail')

      }

    },
    sendEnterprise(form){

      form.type= this.type
      form.id = this.user_id
      this.email = form.email

      this.api.post('auth/signup-validate-user', form).then(({data}) => {

         this.signUpActivation = true //console.log('this is ok!')


      }).catch(err => {

        console.log('Error')
        if (err.response.status == 403) {
            this.$bus.$emit('registerEnterpriseResponse', err.response.data)
        }

      })

    },
    sendTrainer(form){

      form.append('type', this.type)
      form.append('id', this.user_id)
      this.email = form.email

      this.api.post('auth/signup-validate-user', form).then(({data}) => {

        this.signUpActivation = true //console.log('this is ok!')

      }).catch(err => {

          console.log('Error')
          if (err.response.status == 403) {
            this.$bus.$emit('registerTrainerResponse', err.response.data)
          }

      })
    },
    sendStudent(form){

      form.type= this.type
      form.id = this.user_id
      this.email = form.email

      this.api.post('auth/signup-validate-user', form ).then(({data}) => {

        // this.signUpActivation = true //console.log('this is ok!')
        this.$store.dispatch('authenticate', data).then(() => {
              location.href= '/perfil'
          })


      }).catch(err => {

        console.log('Error')
        if (err.response.status == 403) {
            this.$bus.$emit('registerStudentResponse', err.response.data)
        }

      })

    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/#pages/validate/Validate.vue